import { useLang } from "@/i18n/LanguageContext";
import { Facebook, Phone, MapPin, Mail, ArrowUp } from "lucide-react";

const Footer = () => {
  const { t } = useLang();

  return (
    <footer
      data-testid="footer"
      className="relative bg-[#0a0a0a] border-t border-[#1f1f1f] pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Massive brand */}
        <div className="relative mb-16">
          <h2 className="font-display font-black uppercase tracking-tighter text-[15vw] lg:text-[12vw] leading-[0.85] text-white">
            Dobra
            <br />
            <span className="text-[#1f1f1f]">Lakiernia.</span>
          </h2>
          <a
            href="#top"
            data-testid="back-to-top"
            className="absolute top-2 right-0 w-12 h-12 border border-[#27272a] flex items-center justify-center hover:bg-[#dc2626] hover:border-[#dc2626] hover:text-white transition-all"
          >
            <ArrowUp className="w-5 h-5" />
          </a>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-4 gap-10 mb-12 pb-12 border-b border-[#1f1f1f]">
          <div className="md:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#52525b] mb-3">
              MF · Marcin Folman
            </p>
            <p className="text-sm text-[#a1a1aa] leading-relaxed max-w-sm">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#52525b] mb-4">
              {t("nav.contact")}
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:+48513066040"
                  className="flex items-center gap-2 text-white hover:text-[#dc2626] transition-colors"
                >
                  <Phone className="w-3.5 h-3.5" />
                  +48 513 066 040
                </a>
              </li>
              <li>
                <a
                  href="mailto:biuro@dobralakiernia.pl"
                  className="flex items-center gap-2 text-white hover:text-[#dc2626] transition-colors"
                >
                  <Mail className="w-3.5 h-3.5" />
                  biuro@dobralakiernia.pl
                </a>
              </li>
              <li className="flex items-center gap-2 text-[#a1a1aa]">
                <MapPin className="w-3.5 h-3.5 text-[#dc2626]" />
                Długa 9, 05-100 Nowy Dwór Maz.
              </li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#52525b] mb-4">
              Social
            </p>
            <a
              href="https://www.facebook.com/373188136558449"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="inline-flex items-center gap-2 text-sm text-white hover:text-[#dc2626] transition-colors"
            >
              <Facebook className="w-4 h-4" />
              Facebook
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 font-mono text-[10px] tracking-[0.2em] uppercase text-[#52525b]">
          <p>
            © {new Date().getFullYear()} MF Dobra Lakiernia Proszkowa.{" "}
            {t("footer.rights")}
          </p>
          <div className="flex gap-6">
            <a
              href="https://dobralakiernia.pl/politykaprywatnosc.html"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              {t("footer.privacy")}
            </a>
            <a
              href="https://dobralakiernia.pl/cookie.html"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white"
            >
              {t("footer.cookies")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
